<template>
  <div class="weather-viewer">
    <img :src="`https://openweathermap.org/img/wn/${data.code}.png`">
    <div>{{ data.text }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
.weather-viewer {
  display: flex;
  align-items: flex-start;
  white-space: unset !important;
  img {
    width: 30px;
    margin-top: -5px;
  }
}
</style>
